import { render } from "./HeaderComponent.vue?vue&type=template&id=568479ac&scoped=true&ts=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts"

import "./HeaderComponent.vue?vue&type=style&index=0&id=568479ac&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568479ac"]])

export default __exports__